// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Button_Button__jRcom {
  background-color: #dddddd;
  color: #0d0d0d;
  padding: 32px 16px;
}

.Button_Button__jRcom:hover {
  background-color: #cccccc;
}

.Button_Button__jRcom:active {
  background-color: #aaaaaa;
}

.Button_ModestButton__pZASP {
  background-color: #444444;
  color: #eeeeee;
  padding: 16px 8px;
  font-size: var(--font-size-24);
}

.Button_ModestButton__pZASP:hover {
  background-color: #555555;
}

.Button_ModestButton__pZASP:active {
  background-color: #666666;
}
`, "",{"version":3,"sources":["webpack://./src/components/Button.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".Button {\n  background-color: #dddddd;\n  color: #0d0d0d;\n  padding: 32px 16px;\n}\n\n.Button:hover {\n  background-color: #cccccc;\n}\n\n.Button:active {\n  background-color: #aaaaaa;\n}\n\n.ModestButton {\n  background-color: #444444;\n  color: #eeeeee;\n  padding: 16px 8px;\n  font-size: var(--font-size-24);\n}\n\n.ModestButton:hover {\n  background-color: #555555;\n}\n\n.ModestButton:active {\n  background-color: #666666;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Button": `Button_Button__jRcom`,
	"ModestButton": `Button_ModestButton__pZASP`
};
export default ___CSS_LOADER_EXPORT___;
